import { Controller } from '@hotwired/stimulus'

// Switches the displayed subscription prices between the monthly and the
// yearly interval, and keeps the hidden `interval` form fields in sync so
// the Checkout POST carries the selected one.
export default class extends Controller {
  static targets = ['monthly', 'yearly', 'intervalField', 'intervalButton']
  static values = { interval: { type: String, default: 'monthly' } }

  connect() {
    this.apply()
  }

  switch(event) {
    this.intervalValue = event.params.interval
    this.apply()
  }

  apply() {
    const monthly = this.intervalValue === 'monthly'

    this.monthlyTargets.forEach((element) => {
      element.classList.toggle('hidden', !monthly)
    })
    this.yearlyTargets.forEach((element) => {
      element.classList.toggle('hidden', monthly)
    })
    this.intervalFieldTargets.forEach((field) => {
      field.value = this.intervalValue
    })
    this.intervalButtonTargets.forEach((button) => {
      const active = button.dataset.pricingToggleIntervalParam === this.intervalValue
      // Segmented-control look : the active tab is an elevated white thumb.
      button.classList.toggle('bg-base-100', active)
      button.classList.toggle('shadow-sm', active)
      button.classList.toggle('text-base-content', active)
      button.classList.toggle('text-base-content/60', !active)
      button.setAttribute('aria-pressed', active ? 'true' : 'false')
    })
  }
}
